import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import analytics from '../../../services/analytics';

const ScrollToTop = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    analytics.track();
  }, [location]);

  return children;
};

export default ScrollToTop;
